function ServiceField({
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  maxLength,
  inputMode,
  disabled = false,
}) {
  return (
    <label className="ls-pop__field">
      <span>{label}</span>
      <input
        type={type}
        inputMode={inputMode}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled}
      />
    </label>
  );
}

export default ServiceField;
